<template>
  <div class="allGoods">
      <Header @selCat="selCat" @selPrice="selPrice"></Header>
      <Middle ref="goodsListContent" @initCart="initCart" msg="全部商品"></Middle>
  </div>
</template>

<script>
import Header from "./header";
import Middle from "./middle";

export default {
  components: {
    Header,
    Middle,
  },
  data: function () {
    return {};
  },
  methods: {
    //设置价格
    selPrice(val) {
      this.$refs.goodsListContent.selPrice(val);
    },
    //设置
    selCat(value) {
      this.$refs.goodsListContent.setType(value.cls_no,value.type_field);
    },
    //初始化
    initCart() {
      this.$emit("initCart");
    },
  },
};
</script>
<style lang="scss" scoped>
.allGoods {
  width: 100%;
}
</style>
